<template>
  <div class="toolbar" :style="toolbarStyle">
    <div :class="['toolbar-left', justifyContent]">
      <slot></slot>
      <canvas id="waveform" class="waveform" v-show="showWaveform"></canvas>
    </div>
    <div class="toolbar-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'toolbar',
  props: {
    showWaveform: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: [Number, Array],
      default: 0,
    },
    justifyContent: String,
  },
  computed: {
    toolbarStyle() {
      if (typeof this.padding == 'number') {
        return {
          padding: `${this.padding}px`,
        }
      } else {
        return {
          padding: this.padding.map((item) => item + 'px').join(' '),
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 106px;
  flex: 0 0 106px;
  box-sizing: content-box;
  // padding-right: 40px !important;
  .elst-button {
    margin-right: 12px;
  }
  .waveform {
    flex: 1;
    margin-left: 12rpx;
    height: 80px;
  }
  &-left {
    display: flex;
    align-items: center;
    flex: 1;
    &.center {
      justify-content: center;
    }
  }
  &-right {
    display: flex;
    align-items: center;
  }
}
</style>
